module.exports = __webpack_public_path__ + "img/content.03511f1f.png";